import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Localization_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                d="M8 9C8.55229 9 9 8.55229 9 8C9 7.44772 8.55229 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55229 7.44772 9 8 9Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.75 1C8.75 0.585786 8.41421 0.25 8 0.25C7.58579 0.25 7.25 0.585786 7.25 1V1.2912C4.12129 1.63706 1.63706 4.12129 1.2912 7.25H1C0.585786 7.25 0.25 7.58579 0.25 8C0.25 8.41421 0.585786 8.75 1 8.75H1.2912C1.63706 11.8787 4.12129 14.3629 7.25 14.7088V15C7.25 15.4142 7.58579 15.75 8 15.75C8.41421 15.75 8.75 15.4142 8.75 15V14.7088C11.8787 14.3629 14.3629 11.8787 14.7088 8.75H15C15.4142 8.75 15.75 8.41421 15.75 8C15.75 7.58579 15.4142 7.25 15 7.25H14.7088C14.3629 4.12129 11.8787 1.63706 8.75 1.2912V1ZM2.80317 7.25C3.13205 4.95073 4.95073 3.13205 7.25 2.80317V4C7.25 4.41421 7.58579 4.75 8 4.75C8.41421 4.75 8.75 4.41421 8.75 4V2.80317C11.0493 3.13205 12.8679 4.95073 13.1968 7.25H12C11.5858 7.25 11.25 7.58579 11.25 8C11.25 8.41421 11.5858 8.75 12 8.75H13.1968C12.8679 11.0493 11.0493 12.8679 8.75 13.1968V12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12V13.1968C4.95073 12.8679 3.13205 11.0493 2.80317 8.75H4C4.41421 8.75 4.75 8.41421 4.75 8C4.75 7.58579 4.41421 7.25 4 7.25H2.80317Z"
            />
        </SvgStyled>
    );
};

export default Localization_xs;
